import {SlideStandV3ItemVo} from '../../common/shared/api/nicolas/vo/SlideStandV3ItemVo.interface';
import {LegacySingle} from '../generated/types';
import {createAgeGrade} from './AgeGrade';
import {createSlideType} from './SlideType.enum';

export function createLegacySingle(item: SlideStandV3ItemVo): LegacySingle {
  return {
    productId: Number(item.pid.substring(1)), // pid가 p12345678와 같이 오기 때문에 첫번째 문자열을 제거한다.
    isFree: item.is_free === 'Y',
    slideType: createSlideType(item.slide_type),
    ageGrade: createAgeGrade(item.age_grade),
  };
}
